import styled from 'styled-components';

export const TabContainer = styled.div`
  .react-tabs__tab-list {
    display: flex;
    align-items: stretch;
    margin: 0 25px 35px 25px;

    box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.lightGray};

    & > .swiper-container {
      width: 100%;
    }

    @media(min-width:768px){
      margin: 0 0 35px 0;
    }
  }

  .react-tabs__tab {
    box-sizing: border-box;
    max-width: fit-content;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    min-height: 79px;
    padding-top: 20px;
    padding-bottom: 25px;
    width: auto;

    font-weight: 700;
    font-size: 14px;
    line-height: 1;
    color: ${({ theme }) => theme.black};

    outline: none;

    transition: box-shadow 0.3s;

    user-select: none;
    cursor: pointer;

    &:not(:last-child) {
      margin-right: 25px;
    }

    &--selected {
      box-shadow: inset 0 -4px 0 0 ${({ theme }) => theme.blue};
    }

    svg {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      margin-right: 10px;
    }

    @media(min-width: 768px) {
      padding-bottom: 33px;

      font-size: 16px;
    }
  }

  .react-tabs__tab-panel {
    padding: 0 25px;

    @media(min-width: 768px) {
      padding: 0;
    }
  }
`;
